import EventClass from "common/utils/ui/event-class";
import { EventBus, Events } from "jiffy-store";
import { track } from "jiffy-analytics";

/**
 * Class to handle the click event for the design upload CTA in the PLP library.
 * IMPORTANT: This class is under construction and should not be used in production.
 * Implementation may change in the future.
 */
export default class DesignUploadCtaPlpLibraryUploadClass extends EventClass {
  #designLibraryModalManager;

  event(event, $target) {
    event.preventDefault();
    event.stopPropagation();

    super.event(event, $target);

    EventBus.publish(Events.DESIGN_LIBRARY_MODAL_OPEN);

    track("pdp_design_preview_upload_clicked", {
      target: "My Design Library"
    });
  }
}
